function NorthernCyprus({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_1822)">
  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#F0F0F0"/>
  <path d="M3.87114 5.56543C3.3097 6.21749 2.80002 6.91518 2.34827 7.65237H29.6515C29.1998 6.91518 28.6901 6.21743 28.1286 5.56543H3.87114Z" fill="#D80027"/>
  <path d="M3.8712 26.4346H28.1288C28.6902 25.7825 29.1999 25.0848 29.6516 24.3477H2.34839C2.80008 25.0848 3.30976 25.7825 3.8712 26.4346Z" fill="#D80027"/>
  <path d="M13.9525 13.0742L15.2652 14.8833L17.3913 14.1939L16.0765 16.0014L17.3891 17.8104L15.2638 17.1184L13.949 18.9259L13.9503 16.6908L11.825 15.9988L13.9511 15.3095L13.9525 13.0742Z" fill="#D80027"/>
  <path d="M10.3696 20.5216C7.87237 20.5216 5.84787 18.4971 5.84787 15.9998C5.84787 13.5026 7.87237 11.4781 10.3696 11.4781C11.1482 11.4781 11.8809 11.6749 12.5206 12.0216C11.5171 11.0403 10.1448 10.4346 8.63049 10.4346C5.55687 10.4346 3.06531 12.9262 3.06531 15.9998C3.06531 19.0733 5.55693 21.5649 8.63049 21.5649C10.1448 21.5649 11.5171 20.9593 12.5206 19.9779C11.8809 20.3247 11.1483 20.5216 10.3696 20.5216Z" fill="#D80027"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default NorthernCyprus;
